var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / DZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-DZ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#048345",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 14.6666667,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#E81B42",
    mask: "url(#mask-2)",
    points: "17.3333333 11.04 15.765906 12.1573787 16.3442345 10.3213777 14.7971826 9.17595468 16.7220366 9.15862229 17.3333333 7.33333333 17.94463 9.15862229 19.869484 9.17595468 18.3224321 10.3213777 18.9007607 12.1573787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7509001,4 C15.2712322,4 16.6537735,4.61550603 17.6820863,5.62070525 C16.9732717,5.28169377 16.1700274,5.09090909 15.3193274,5.09090909 C12.4319325,5.09090909 10.0912364,7.28878396 10.0912364,10 C10.0912364,12.711216 12.4319325,14.9090909 15.3193274,14.9090909 C16.1700274,14.9090909 16.9732717,14.7183062 17.6831793,14.3798184 C16.6537735,15.384494 15.2712322,16 13.7509001,16 C10.5747657,16 8,13.3137085 8,10 C8,6.6862915 10.5747657,4 13.7509001,4 Z",
    id: "Oval-3",
    fill: "#E81B42",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/DZ.8f935063c74d558daded855e161e086e.svg";
export { ForwardRef as ReactComponent };